// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionCard_root_2dGFH"};